<template lang="pug">
form(@submit.prevent="generate")
  modal(active, title="Selecionar débitos", @close="$router.back()")
    div(slot="modal-body")
      load-manager.scrollable(:errors="errors", :loading="loading")
        .container.grid-lg(v-if="debitos.length > 0")
          .columns
            .column.col-6.col-sm-12.my-2(v-for="debito in debitos")
              row(:debito="debito")
        .empty.mx-2(v-else)
          .empty-icon
            i.icon.icon-search.icon-3x
          p.empty-title.h5 Nada para exibir
          p.empty-subtitle Nenhum registro encontrado
    div(slot="modal-footer")
      button.btn.btn-primary(
        :class="{ loading: loadingBoleto }",
        :disabled="!buttonEnabled",
        v-if="showButton"
      ) Gerar boleto
</template>

<script>
import showMixin, { defaultStoreImports } from "@/mixins/show";
import api from "@/api/debitos";
import Row from "./Row";
import toastErrors from "@/lib/errors/toastErrors";

export default {
  vuex: { debitos: defaultStoreImports },
  components: { Row },
  data() {
    return { loadingBoleto: false };
  },
  computed: {
    debitos() {
      return this.current ? this.current.rows : [];
    },
    showButton() {
      return this.debitos.length > 0;
    },
    buttonEnabled() {
      const index = this.debitos.findIndex((i) => i.selected);
      return index > -1;
    },
  },
  methods: {
    async generate() {
      try {
        this.loadingBoleto = true;
        const { id } = this.$route.params;
        const { url } = await api.create(id, this.current);
        window.open(url, "_blank");
      } catch (e) {
        toastErrors(e);
      } finally {
        this.loadingBoleto = false;
      }
    },
  },
  mixins: [showMixin],
};
</script>
